import { AccaBoostLayoutProvider } from '../model';

export abstract class BaseAccaBoostComponent {
    constructor(private layoutService: AccaBoostLayoutProvider) {}

    get isDesktop(): boolean {
        return this.layoutService.isDesktop;
    }
}
